<template>
  <div id="list">
    <div class="row">
      <div class="col-12 col-lg-6">
        <h4 class="font-weight-bold">Listado general de Usuarios</h4>
      </div>
      <div class="col-12 col-lg-6 text-lg-right mb-3">
        <router-link to="/usuarios/nuevo" class="btn btn-success px-4">
          Nuevo usuario
        </router-link>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="keyword">Búsqueda rápida de usuarios</label>
          <input type="text" class="form-control" placeholder="Busque por nombre, apellido, correo electrónico..." v-model.trim="keyword">
        </div>
      </div>
      <div class="col-12 col-lg-6 d-lg-flex align-items-center justify-content-lg-end">
        <span class="text-muted">Mostrando {{users.length}} resultados.</span>
      </div>
      <div class="col-12 mt-3">
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Apellidos</th>
                <th>Correo Electrónico</th>
                <th>Fecha de Creación</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!results.length">
                <td colspan="5">No se encontraron resultados.</td>
              </tr>
              <tr v-for="(user, index) in results"
              v-bind:key="index">
                <td>{{user.name}}</td>
                <td>{{user.lastName}}</td>
                <td>{{user.email}}</td>
                <td>{{user.createdAt | date}}</td>
                <td>
                  <a href="javascript:;"
                    class="text-primary mr-3"
                    v-on:click.prevent="handleUpdate(user.id)">
                    Ver / Modificar
                  </a>
                  <a href="javascript:;"
                    class="text-danger mr-3"
                    v-on:click.prevent="handleDelete(user.id)"
                    v-if="authenticated && user.id !== $store.state.user.uid">
                    Eliminar
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firestore, } from "@/firebase";
  import axios from "axios";
  export default {
    data() {
      return {
        users: [],
        keyword: "",
      };
    },
    computed: {
      authenticated() {
        return !!this.$store.state.user;
      },
      results() {
        return this.users.filter(user => user.name.trim().toLowerCase().includes(this.keyword.toLowerCase())
          || user.lastName.trim().toLowerCase().includes(this.keyword.toLowerCase())
          || user.email.trim().toLowerCase().includes(this.keyword.toLowerCase())
        );
      },
    },
    methods: {
      async getUsers() {
        this.users = [];
        const snapshot = await firestore.collection("/users")
          .where("deleted", "==", false)
          .get();
        snapshot.forEach(doc => {
          this.users.push({ ...doc.data(), id: doc.id, });
        });
      },
      handleUpdate(id) {
        this.$store.commit("SET_EDIT_USER", this.users.find(a => a.id == id));
        this.$router.push({
          name: "UpdateUser",
          params: { id, },
        });
      },
      async handleDelete(id) {
        const confirm = await this.$swal({
          title: "¿Seguro que deseas eliminar a este usuario?",
          buttons: ["Cancelar", "Confirmar"],
        });
        if (confirm)
          try {
            await axios.delete(`${process.env.VUE_APP_API_URL}/users/${id}`);
            this.getUsers();
            this.$swal("Operación exitosa", "Usuario eliminado con éxito", "success");
          } catch(e) {
            console.error(e);
            this.$swal("Error", e.response.data, "error");
          }
      },
    },
    created() {
      this.getUsers();
    },
  };
</script>